<template>
  <fieldset id="group">
    <div v-for="(option, i) in options" :key="option.id">
      <!-- Options -->
      <label
        :for="option.id"
        class="d-flex flex-row style-option-container scss-click-effect align-items-center mx-4"
      >
        <div class="flex-grow-1">
          <span class="d-flex justify-content-start">{{
            formatDisplayNameFunction
              ? formatDisplayNameFunction(option)
              : option.name
          }}</span>
        </div>
        <div>
          <input
            type="radio"
            :id="option.id"
            :value="option.id.toString()"
            name="group"
            @click="$emit('update:modelValue', parseInt($event.target.value))"
            :checked="option.id === modelValue"
          />
        </div>
      </label>
      <!-- Seperator -->
      <div
        class="my-2"
        style="background-color: #dadada; height: 0.5px"
        v-if="options.length - 1 !== i"
      >
        &nbsp;
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "RadioButton",
  props: {
    options: {
      type: Object,
      required: true,
    },
    formatDisplayNameFunction: {
      type: Function,
      required: false,
    },
    modelValue: { required: true },
  },
  emits: ["update:modelValue"],
};
</script>

<style scoped>
.style-option-container {
  height: 50px;
}
</style>
